import { MooringServiceCorridorDirection } from './MooringSiteSetup';

export class MooringDrawingSetup {
  MooringId!: number;

  // CageSize: number;
  PenCircumference: number;
  GridLineLength: number;

  SiteAngleFromNorth: number;
  FleetAngleFromNorth: number;

  CenterPositionLat?: string;
  CenterPositionLong?: string;

  FleetCenterPositionLat?: string;
  FleetCenterPositionLong?: string;

  NWPositionLat?: string;
  NWPositionLong?: string;

  NEPositionLat?: string;
  NEPositionLong?: string;

  SWPositionLat?: string;
  SWPositionLong?: string;

  SEPositionLat?: string;
  SEPositionLong?: string;

  ServiceCorridor?: {
    Direction: MooringServiceCorridorDirection;
    Placement: number;
    Width: number;
  };

  Cages: CageDrawingPropertyDto[];
  Buoys: BuoyDrawingPropertyDto[];
  GridLines: GridLineDrawingPropertyDto[];
  AnchorLines: AnchorLineDrawingPropertyDto[];
  FleetAnchorLines: FleetAnchorLineDrawingPropertyDto[];
  Bridles: BridleDrawingPropertyDto[];
}

export class CageDrawingPropertyDto {
  Id: number;
  MooringNo: string;
  AnalysisNo: string;
  Column: number;
  Row: number;
  PenCircumference: number;
}

export class BuoyDrawingPropertyDto {
  Id: number;
  MooringNo: string;
  AnalysisNo: string;
  IsLightBuoy: boolean;
  Column: number;
  Row: number;
}

export class GridLineDrawingPropertyDto {
  Id: number;
  MooringNo: string;
  AnalysisNo: string;
  IsAccident: boolean;
  FromBuoyId: number;
  ToBuoyId: number;
}

export class AnchorLineDrawingPropertyDto {
  Id: number;
  MooringNo: string;
  AnalysisNo: string;
  IsAccident: boolean;
  BuoyId: number;

  AnchorLat?: string;
  AnchorLong?: string;
}

export class FleetAnchorLineDrawingPropertyDto {
  Id: number;

  MooringNo: string;
  AnalysisNo: string;

  CornerNo: number;

  IsAccident: boolean;

  AnchorLat?: string;
  AnchorLong?: string;
}

export class BridleDrawingPropertyDto {
  Id: number;
  MooringNo: string;
  AnalysisNo: string;
  BuoyId: number;
  CageId: number;
}
